// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options } from '@hey-api/client-fetch';
import type { GetParkingParkingGetError, GetParkingParkingGetResponse, GetMicromobilityMicromobilityGetError, GetMicromobilityMicromobilityGetResponse, GetMicromobilityDetailMicromobilityMicromobilityIdGetData, GetMicromobilityDetailMicromobilityMicromobilityIdGetError, GetMicromobilityDetailMicromobilityMicromobilityIdGetResponse, GetTripTripsTripIdGetData, GetTripTripsTripIdGetError, GetTripTripsTripIdGetResponse, GetTripGeometryTripsTripIdGeometryGetData, GetTripGeometryTripsTripIdGeometryGetError, GetTripGeometryTripsTripIdGeometryGetResponse, GetTripWithGeometryTripsTripIdUiGetData, GetTripWithGeometryTripsTripIdUiGetError, GetTripWithGeometryTripsTripIdUiGetResponse, GetVehicleLocationsTripsTripIdVehiclesGetData, GetVehicleLocationsTripsTripIdVehiclesGetError, GetVehicleLocationsTripsTripIdVehiclesGetResponse, ListVehiclesVehiclesLocationsGetError, ListVehiclesVehiclesLocationsGetResponse, ListStopsStopsGetError, ListStopsStopsGetResponse, GetStopStopsStopIdGetData, GetStopStopsStopIdGetError, GetStopStopsStopIdGetResponse, ListArrivalsStopsStopIdArrivalsGetData, ListArrivalsStopsStopIdArrivalsGetError, ListArrivalsStopsStopIdArrivalsGetResponse, ListScheduleStopsStopIdScheduleDateGetData, ListScheduleStopsStopIdScheduleDateGetError, ListScheduleStopsStopIdScheduleDateGetResponse, SearchGeocodingSearchGetData, SearchGeocodingSearchGetError, SearchGeocodingSearchGetResponse, ReverseGeocodeGeocodingReverseGeocodeGetData, ReverseGeocodeGeocodingReverseGeocodeGetError, ReverseGeocodeGeocodingReverseGeocodeGetResponse, GetPlanPlanTransportModesFromLonLatToLonLatGetData, GetPlanPlanTransportModesFromLonLatToLonLatGetError, GetPlanPlanTransportModesFromLonLatToLonLatGetResponse, RobotsRobotsTxtGetError, RobotsRobotsTxtGetResponse } from './types.gen';

export const client = createClient(createConfig());

/**
 * Get Parking
 */
export const getParkingParkingGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => { return (options?.client ?? client).get<GetParkingParkingGetResponse, GetParkingParkingGetError, ThrowOnError>({
    ...options,
    url: '/parking/'
}); };

/**
 * Get Micromobility
 */
export const getMicromobilityMicromobilityGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => { return (options?.client ?? client).get<GetMicromobilityMicromobilityGetResponse, GetMicromobilityMicromobilityGetError, ThrowOnError>({
    ...options,
    url: '/micromobility/'
}); };

/**
 * Get Micromobility Detail
 */
export const getMicromobilityDetailMicromobilityMicromobilityIdGet = <ThrowOnError extends boolean = false>(options: Options<GetMicromobilityDetailMicromobilityMicromobilityIdGetData, ThrowOnError>) => { return (options?.client ?? client).get<GetMicromobilityDetailMicromobilityMicromobilityIdGetResponse, GetMicromobilityDetailMicromobilityMicromobilityIdGetError, ThrowOnError>({
    ...options,
    url: '/micromobility/{micromobility_id}'
}); };

/**
 * Get Trip
 */
export const getTripTripsTripIdGet = <ThrowOnError extends boolean = false>(options: Options<GetTripTripsTripIdGetData, ThrowOnError>) => { return (options?.client ?? client).get<GetTripTripsTripIdGetResponse, GetTripTripsTripIdGetError, ThrowOnError>({
    ...options,
    url: '/trips/{trip_id}'
}); };

/**
 * Get Trip Geometry
 */
export const getTripGeometryTripsTripIdGeometryGet = <ThrowOnError extends boolean = false>(options: Options<GetTripGeometryTripsTripIdGeometryGetData, ThrowOnError>) => { return (options?.client ?? client).get<GetTripGeometryTripsTripIdGeometryGetResponse, GetTripGeometryTripsTripIdGeometryGetError, ThrowOnError>({
    ...options,
    url: '/trips/{trip_id}/geometry'
}); };

/**
 * Get Trip With Geometry
 * Returns trip with geometry.
 */
export const getTripWithGeometryTripsTripIdUiGet = <ThrowOnError extends boolean = false>(options: Options<GetTripWithGeometryTripsTripIdUiGetData, ThrowOnError>) => { return (options?.client ?? client).get<GetTripWithGeometryTripsTripIdUiGetResponse, GetTripWithGeometryTripsTripIdUiGetError, ThrowOnError>({
    ...options,
    url: '/trips/{trip_id}/ui'
}); };

/**
 * Get Vehicle Locations
 * List vehicles for one or more trips. Multiple trip IDs can be provided as a comma-separated list.
 */
export const getVehicleLocationsTripsTripIdVehiclesGet = <ThrowOnError extends boolean = false>(options: Options<GetVehicleLocationsTripsTripIdVehiclesGetData, ThrowOnError>) => { return (options?.client ?? client).get<GetVehicleLocationsTripsTripIdVehiclesGetResponse, GetVehicleLocationsTripsTripIdVehiclesGetError, ThrowOnError>({
    ...options,
    url: '/trips/{trip_id}/vehicles'
}); };

/**
 * List Vehicles
 */
export const listVehiclesVehiclesLocationsGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => { return (options?.client ?? client).get<ListVehiclesVehiclesLocationsGetResponse, ListVehiclesVehiclesLocationsGetError, ThrowOnError>({
    ...options,
    url: '/vehicles/locations'
}); };

/**
 * List Stops
 */
export const listStopsStopsGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => { return (options?.client ?? client).get<ListStopsStopsGetResponse, ListStopsStopsGetError, ThrowOnError>({
    ...options,
    url: '/stops/'
}); };

/**
 * Get Stop
 * Get stop details
 */
export const getStopStopsStopIdGet = <ThrowOnError extends boolean = false>(options: Options<GetStopStopsStopIdGetData, ThrowOnError>) => { return (options?.client ?? client).get<GetStopStopsStopIdGetResponse, GetStopStopsStopIdGetError, ThrowOnError>({
    ...options,
    url: '/stops/{stop_id}'
}); };

/**
 * List Arrivals
 * List arrivals for a stop, optionally filtered by date (YYYYMMDD) and current time (true/false)
 */
export const listArrivalsStopsStopIdArrivalsGet = <ThrowOnError extends boolean = false>(options: Options<ListArrivalsStopsStopIdArrivalsGetData, ThrowOnError>) => { return (options?.client ?? client).get<ListArrivalsStopsStopIdArrivalsGetResponse, ListArrivalsStopsStopIdArrivalsGetError, ThrowOnError>({
    ...options,
    url: '/stops/{stop_id}/arrivals'
}); };

/**
 * List Schedule
 * List schedule for a stop, filtered by date (YYYYMMDD)
 */
export const listScheduleStopsStopIdScheduleDateGet = <ThrowOnError extends boolean = false>(options: Options<ListScheduleStopsStopIdScheduleDateGetData, ThrowOnError>) => { return (options?.client ?? client).get<ListScheduleStopsStopIdScheduleDateGetResponse, ListScheduleStopsStopIdScheduleDateGetError, ThrowOnError>({
    ...options,
    url: '/stops/{stop_id}/schedule/{date}'
}); };

/**
 * Search
 */
export const searchGeocodingSearchGet = <ThrowOnError extends boolean = false>(options: Options<SearchGeocodingSearchGetData, ThrowOnError>) => { return (options?.client ?? client).get<SearchGeocodingSearchGetResponse, SearchGeocodingSearchGetError, ThrowOnError>({
    ...options,
    url: '/geocoding/search'
}); };

/**
 * Reverse Geocode
 */
export const reverseGeocodeGeocodingReverseGeocodeGet = <ThrowOnError extends boolean = false>(options: Options<ReverseGeocodeGeocodingReverseGeocodeGetData, ThrowOnError>) => { return (options?.client ?? client).get<ReverseGeocodeGeocodingReverseGeocodeGetResponse, ReverseGeocodeGeocodingReverseGeocodeGetError, ThrowOnError>({
    ...options,
    url: '/geocoding/reverse_geocode'
}); };

/**
 * Get Plan
 * Gets plan for trip. Transport modes are comma separated, e.g. WALK,BUS. From and to lon,lat are comma separated, e.g. 14.5058,46.0569.
 */
export const getPlanPlanTransportModesFromLonLatToLonLatGet = <ThrowOnError extends boolean = false>(options: Options<GetPlanPlanTransportModesFromLonLatToLonLatGetData, ThrowOnError>) => { return (options?.client ?? client).get<GetPlanPlanTransportModesFromLonLatToLonLatGetResponse, GetPlanPlanTransportModesFromLonLatToLonLatGetError, ThrowOnError>({
    ...options,
    url: '/plan/{transport_modes}/{from_lon_lat}/{to_lon_lat}'
}); };

/**
 * Robots
 */
export const robotsRobotsTxtGet = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => { return (options?.client ?? client).get<RobotsRobotsTxtGetResponse, RobotsRobotsTxtGetError, ThrowOnError>({
    ...options,
    url: '/robots.txt'
}); };